<template>
    <v-container>
        <v-toolbar flat>
            <v-card-actions>
                <v-icon @click="$router.go(-1)" color="secondary"  style="margin-right: 10px">
                    mdi-arrow-left-thick
                </v-icon>
            </v-card-actions>
            
            <v-toolbar-title style=""><b>Add Seasonal Discount</b></v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-form ref="form" @submit.prevent="saveDiscount" class="custom_form">
            <v-card>
                <v-container>
                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <div class="mt-2 pr-5">
                                <b>Discount Name</b>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="discount.name"
                                outlined
                                dense 
                                clearable
                                :rules="discountNameRules"
                                :success="discountNameSuccess"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    
                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <div class="mt-2 pr-5">
                                <b>Percentage</b>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="discount.discountPercentage"
                                outlined
                                dense 
                                clearable
                                :rules="discountPercentageRules"
                                :success="discountPercentageSuccess"
                            ></v-text-field>
                        </v-col>
                    </v-row>


                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <div class="mt-2 pr-5">
                                <b>Coupon Code</b>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="discount.couponCode"
                                outlined
                                dense 
                                clearable
                                :rules="discountCouponCodeRules"
                                :success="discountCouponCodeSuccess"
                            ></v-text-field>
                        </v-col>
                    </v-row>


                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <div class="mt-2 pr-5">
                                <b>Time Duration</b>
                            </div>
                        </v-col>
                        <v-col cols="2">

                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="discount.startDate"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="discount.startDate" 
                                    outlined
                                    dense 
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="discount.startDate" :min="minDate" @click:date="setStartDateOnSecondPicker"
                                no-title
                                scrollable
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu = false"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu.save(discount.startDate)"
                                >
                                    OK
                                </v-btn>
                                </v-date-picker>
                            </v-menu>

                        </v-col>
                        <v-col cols="2" class = "ml-5">

                            <v-menu
                                ref="menu1"
                                v-model="menu1"
                                :close-on-content-click="false"
                                :return-value.sync="discount.endDate"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="discount.endDate"
                                    outlined
                                    dense 
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="discount.endDate" :min="secondMinDate"
                                no-title
                                scrollable
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu1 = false"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu1.save(discount.endDate)"
                                >
                                    OK
                                </v-btn>
                                </v-date-picker>
                            </v-menu>

                        </v-col>                        
                    </v-row>

                    <v-row v-if="errorMessage || successMessage">
                        <v-col cols="6" offset-md="2">
                            <v-alert v-if="errorMessage" type="error">
                                {{errorMessage}}
                            </v-alert>
                            <v-alert v-if="successMessage" type="success">
                                {{successMessage}}
                            </v-alert>
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>
                    
                    <v-row>
                        <v-col cols="10">
                            <v-card-actions style="justify-content:center;">
                                <v-btn class="mx-5" text @click="$router.go(-1)">cancel</v-btn>
                                <v-btn
                                    class="mx-5"
                                    :disabled="disabled"
                                    type="submit"
                                    color="secondary"
                                    width="90"
                                    @click="saveDiscount"
                                    >Submit</v-btn
                                >
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-form>
    </v-container>
</template>

<script>
import SeasonalDiscount from "../../models/SeasonalDiscount";
//import {mapMutations } from "vuex";
export default {
     beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id)
                   vm.$router.push("/");
            }, 0);
        });
    },
    name: "AddSeasonalDiscount",
    data() {
        return {

            startDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            endDate:"",
            //minDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            minDate: new Date().toISOString().slice(0,10),
            secondMinDate: new Date().toISOString().slice(0,10),
            menu: false,
            menu1: false,

            discount: new SeasonalDiscount(),
            
            successMessage:'',
            errorMessage:'',
            disabled:false,
            textField:null,
            inputType: '',
            //courseTitle:"abcd",
            //course.courseStatus:true,
            discountNameSuccess:false,
            discountNameRules: [
                v => {
                    if (v) {
                        this.discountNameSuccess = true;
                        return true;
                    } else {
                        this.discountNameSuccess = false;
                        return "Name is required";
                    }
                },
                v => (v || "").length >= 2 || "Name must be at least 2 characters long", //to ask for the models
                v => (v || "").length <= 30 || "Name must be less than 30 characters" //to ask for the models, //earlier 30
            ],

            discountPercentageSuccess:false,
            discountPercentageRules: [
                v => {
                    if (v) {
                        this.discountPercentageSuccess = true;
                        return true;
                    } else {
                        this.discountPercentageSuccess = false;
                        return "Percentage is required";
                    }
                },
                v =>  !isNaN(Number(v || "")) || "Percentag must be number", //to ask for the models
            ],

            discountCouponCodeSuccess:false, 
            discountCouponCodeRules:[
                v => {
                    if (v) {
                        this.discountCouponCodeSuccess = true;
                        return true;
                    } else {
                        this.discountCouponCodeSuccess = false;
                        return "Coupon Code is required";
                    }
                },
                v => (v || "").length >= 2 || "Coupon Code must be at least 2 characters long", //to ask for the models
                v => (v || "").length <= 20 || "Coupon Code must be less than 20 characters", //to ask for the models, //earlier 10
                v => (/^[A-Za-z0-9]{2,20}$/gm.test(v)) || "Coupon Code must be between 2 to 20 chars long and contain alphabets & digits only"
            ]
        }
    },
    computed: {
        auth() {
            return this.$store.state.auth;
        }
    },

    methods: {



        setStartDateOnSecondPicker (date) {

           // alert(`You have just double clicked the following date: ${date}`)
            const d = new Date(date);
            console.log('set secondd date', d);
            this.secondMinDate =  d.toISOString().substr(0, 10);
        },

        saveDiscount() {
            this.disabled = true;
            //console.log('title', this.course.courseTitle);
            if ((this.discount.name.length<2 ||this.discount.name.length>30) ||  (this.discount.name.trim().length === 0)) //earlier 30
            {
                this.errorMessage = 'Discount Name should be valid';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }

            if (this.discount.discountPercentage.trim().length === 0 || isNaN(Number(this.discount.discountPercentage.trim())) )//earlier 255
            {
                this.errorMessage = 'Percentage should be valid';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }

            if (this.discount.couponCode.trim().length === 0 ||  !/^[A-Za-z0-9]{2,20}$/gm.test(this.discount.couponCode.trim()) )//earlier 255
            {
                this.errorMessage = 'Coupon Code should contain only alpha and digits. Length of coupon code should be between 2 to 20 chars.';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }

            if (this.discount.startDate.trim().length === 0 )//earlier 255
            {
                this.errorMessage = 'Start Date should not be left empty';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }


            if (this.discount.endDate.trim().length === 0 )//earlier 255
            {
                this.errorMessage = 'End Date should not be left empty';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }


            SeasonalDiscount.postDiscount( this.discount, this.auth.token)
            .then( res => {
                this.disabled = false;
                console.log('res', res);
                this.successMessage = 'Discount added successfully';
                setTimeout(() => (this.successMessage = ""), 5000);
                this.$refs.form.reset();
                this.discount.startDate= "";
                this.discount.endDate= "";
            })
            .catch( err => {
                this.errorMessage = err.response.data;
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                this.$refs.form.reset(); 
            });
        },

        clearForm(){
            this.$refs.form.resetValidation();
        },

    }, 
    mounted(){

    }
}
</script>
<style scoped>
.custom_form {
    margin: 10px 0 0;
    border-top: 3px solid #1b73ba;
}
.custom_form >>> .v-card {
    padding-top: 20px;
}
</style>